import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text, TextPriority } from 'wix-ui-tpa/cssVars';
import { classes, st } from './DiscountName.st.css';

type DiscountNameProps = {
  discountName: string | undefined;
  showCalculatedAtCheckout: boolean;
};

export const DiscountName: FC<DiscountNameProps> = ({
  discountName,
  showCalculatedAtCheckout,
}) => {
  const { isMobile } = useEnvironment();
  const { t } = useTranslation();

  if (!discountName) {
    return null;
  }

  return (
    <div
      data-hook="details-discount-name"
      className={st(classes.root, { isMobile })}
    >
      <Text className={classes.discountName}>{discountName}</Text>
      {showCalculatedAtCheckout && (
        <Text
          data-hook="details-calculated-at-checkout"
          className={classes.calculatedAtCheckout}
          priority={TextPriority.secondary}
        >
          {t('service-details.calculated-at-checkout')}
        </Text>
      )}
    </div>
  );
};
